export default __webpack_public_path__ + "static/media/down-arrow.4b3a54fc.svg";